import { ModelDef } from '@shared/model'
import { AxE2ConfigModelDef } from '../services/$AxE2Config'
import { $axFrontendHelper, AxTokenResponse } from '../services/$axFrontendHelper'
import { $toast } from '../services/$toast'
import { axApiPaths } from '@/AxApiPaths'
import { userColumns } from './_userColumnsForSignup'
import { $urlHelper } from '../services/$urlHelper'

export const isValidZipCode = (value): boolean => /^\d+$/.test(value) === true && value.length === 7

export const axUserColumns = [
  'id',
  'name',
  'name_read',
  'email',
  'password',
  'gender',
  'birthday',
  'tel_primary',
  'tel_secondary',
  'fax',
  'zip',
  'country',
  'state',
  'city',
  'street',
  'building',
  'company',
  'company_read',
  'company_division',
  'company_position',
  'accept_makerepeater_mail',
  'custom',
  'custom.camp_entry',
  'custom.camp_entry_date',
  'custom.teiki_order_customer',
  'custom.family_name',
  'custom.reputation',
  'custom.family_name_kana',
  'custom.reputation_kana',
  'custom.my_message',
  'custom.cumulative_amount',
  'custom.membership_rank',
  'custom.cloudk_memberid',
  'custom.credit_transfer_permisson',
  'custom.gmo_pg_member_id',
  'new_password',
  'password_confirm',
  'socialPlusToken',
  'socialPlusUserId',
  'snsType',
  'goToNext',
]

export const signupColumns = {
  accept_makerepeater_mail: true,
  id: '',
  custom : {
  family_name: '',
  reputation: '',
  family_name_kana: '',
  reputation_kana: '',
  },
  zip: '',
  state:'',
  city: '',
  street: '',
  building: '',
  tel_number1: '',
  tel_number2: '',
  tel_number3: '',
  gender: '',
  birthday_y: '',
  birthday_m: '',
  birthday_d: '',
  email: '',
  password: '',
  password_confirm: '',
  socialPlusToken: '',
  socialPlusUserId: '',
  snsType: '',
}

export const formatUserDataForSave = (data) => {
  const hasValidBirthday = data.birthday_y && data.birthday_m && data.birthday_d
  if (hasValidBirthday) {
    data.birthday = `${data.birthday_y}-${data.birthday_m
      .toString()
      .padStart(2, '0')}-${data.birthday_d.toString().padStart(2, '0')}`
  }

  const hasValidTelphone = data.tel_number1 && data.tel_number2 && data.tel_number3
  if(hasValidTelphone){
    data.tel_primary = data.tel_number1 + '-' + data.tel_number2 + '-' + data.tel_number3
  }

  // 入力した姓と名を合わせて、フルネームにする
  const hasValidName = data.custom.family_name && data.custom.reputation
  const hasValidNameKana = data.custom.family_name_kana && data.custom.reputation_kana

  if(hasValidName){
    data.name = data.custom.family_name + ' ' + data.custom.reputation
  }
  if(hasValidNameKana){
    data.name_read = data.custom.family_name_kana + ' ' + data.custom.reputation_kana
  }

  // 名前
  if (data.name) {
    data.name = $urlHelper.escapeQueryParams(data.name)
  }

  // フリガナ
  if (data.name_read) {
    data.name_read = $urlHelper.escapeQueryParams(data.name_read)
  }


  // 氏名 姓
  if (data.custom.family_name) {
    data.custom.family_name = $urlHelper.escapeQueryParams(data.custom.family_name)
  }

  // 氏名 名
  if (data.custom.reputation) {
    data.custom.reputation = $urlHelper.escapeQueryParams(data.custom.reputation)
  }

  // 氏名 フリガナ　セイ
  if (data.custom.family_name_kana) {
    data.custom.family_name_kana = $urlHelper.escapeQueryParams(data.custom.family_name_kana)
  }

   // 氏名 フリガナ　メイ
   if (data.custom.reputation_kana) {
    data.custom.reputation_kana = $urlHelper.escapeQueryParams(data.custom.reputation_kana)
  }

  // 市区町村
  if (data.city) {
    data.city = $urlHelper.escapeQueryParams(data.city)
  }
  // 町村字番地
  if (data.street) {
    data.street = $urlHelper.escapeQueryParams(data.street)
  }
  // 建物名（部屋番号）
  if (data.building) {
    data.building = $urlHelper.escapeQueryParams(data.building)
  } else {
    data.building = ''
  }

  // ソーシャルプラス
  if(data.socialPlusToken){
    data.socialPlusToken = $urlHelper.escapeQueryParams(data.socialPlusToken)
  }else{
    data.socialPlusToken = ''
  }

  if(data.socialPlusUserId){
    data.socialPlusUserId = $urlHelper.escapeQueryParams(data.socialPlusUserId)
  }else{
    data.socialPlusUserId = ''
  }

  if(data.snsType){
    data.snsType = $urlHelper.escapeQueryParams(data.snsType)
  }else{
    data.snsType = ''
  }

  return data
}

export const formatUserDataForAxRequest = (data) => {
  data = formatUserDataForSave(data)
  data = $axFrontendHelper.cleanupObjectForRequest(data, axUserColumns)
  return data
}

export const formatNewPasswordDataForAxREquest = (data) => {
  data = formatUserDataForSave(data)
  data = $axFrontendHelper.cleanupObjectForRequest(data, axUserColumns)
  return data.new_password
}

export const executeSignUp = async(data) => {
  data = formatUserDataForSave(data)
  try {
      await $axFrontendHelper.requestToNormal({
      params:{axApiPath: axApiPaths.users.create},
      data: data,
      path: '/member/signup',
      method:'POST'
      })
      $toast.success('会員登録が完了しました')
      return data
  }catch(e){
      const errorCode = e.response.data.message
      if(errorCode === '007-003'){
        $toast.error('すでに登録のある会員メールアドレスです。ログインしてください。')
        return errorCode
      }
      $toast.error('会員登録できませんでした。ご入力いただいた内容をご確認下さい。')
      return false
  }
}

export const signup: ModelDef & AxE2ConfigModelDef<any> = {
  tableName: 'signup',
  tableLabel: '新規会員登録',
  defaultSort: { key: 'createdAt', order: 'desc' },
  columns: userColumns,
  timestamps: false,
  onSubmitFunction: executeSignUp,
}

export const validate = (data,errors,classAddList,classRemoveList) => {
  /*
      バリデーション処理
  */
  const colDef = userColumns
  let col = {}
  let colData = {}
  errors.flag = false

  for(const keyname in data){
    if(keyname === 'custom'){
      for(const custom_keyname in data[keyname]){
        col[custom_keyname] = data[keyname][custom_keyname]
      }
    }
  }
  colData = Object.assign(col,data)
  delete colData['custom']

  for(const keyname in colData){
    errors[keyname] = {}
    if(colDef[keyname] && colDef[keyname].validate){
        let err = []
        const passwordValidator = 'passwordValidator'
        const isNotEmptyPassword = 'isNotEmptyPassword'
        classRemoveList(keyname)
        Object.keys(colDef[keyname].validate).map((key) => {
            let errormessage = '';
            const labelname = colDef[keyname].label
            // keyはモデルのバリデーションによるキーのこと(models/_userColumnsForSignup.ts)
            if(key === 'sameWithPassword'){
              // パスワードが不一致の場合に処理
              errormessage = colDef[keyname].validate[key](colData[keyname],colData['password'])
            }else{
              errormessage = colDef[keyname].validate[key](colData[keyname],labelname)
            }

            if(errormessage){
              if(key === isNotEmptyPassword){
                classAddList(keyname)
              }else{
                classAddList(keyname)
                err.push(errormessage)
              }
            }
            // console.log(`エラーチェック:${keyname}=>`+ labelname + ':' + errormessage)
        })
        if(err.length !== 0){
            errors[keyname].message = err
            errors[keyname].flag = true
            errors.flag = true
        }
      }
    }
}
